/* Step 6: Postal code delivery checker.
 * Validates a Canadian postal code, looks up the FSA centroid in QC_FSAS,
 * computes haversine distance from Montreal (45.5017, -73.5673), and
 * reports free vs paid delivery zone (100 km threshold).
 *
 * Expand QC_FSAS as needed — current set covers Greater Montreal,
 * Laval, Montérégie, Lanaudière, Laurentides, plus reference centroids
 * for Drummondville, Sherbrooke, Trois-Rivières, Québec, Gatineau.
 * Source: approximate FSA centroids; refine from Statistics Canada data.
 */
(function () {
  'use strict';

  var MONTREAL = [45.5017, -73.5673];
  var FREE_KM  = 100;
  // FSAs always treated as free-delivery, even if great-circle distance > FREE_KM.
  // Drummondville sits ~95-115 km depending on FSA + measurement method;
  // the merchant explicitly extends the free zone to cover all of it.
  var FREE_FSA_OVERRIDE = ['J2A', 'J2B', 'J2C', 'J2E'];

  var QC_FSAS = {
    // --- Montreal Island (all H FSAs are within ~25 km of downtown) ---
    'H1A': [45.660, -73.500], 'H1B': [45.620, -73.510], 'H1C': [45.640, -73.580],
    'H1E': [45.660, -73.560], 'H1G': [45.580, -73.640], 'H1H': [45.580, -73.620],
    'H1J': [45.595, -73.555], 'H1K': [45.585, -73.545], 'H1L': [45.575, -73.525],
    'H1M': [45.555, -73.535], 'H1N': [45.555, -73.555], 'H1P': [45.575, -73.620],
    'H1R': [45.575, -73.650], 'H1S': [45.555, -73.580], 'H1T': [45.555, -73.595],
    'H1V': [45.560, -73.530], 'H1W': [45.545, -73.555], 'H1X': [45.545, -73.580],
    'H1Y': [45.535, -73.595], 'H1Z': [45.555, -73.610],
    'H2A': [45.555, -73.625], 'H2B': [45.580, -73.665], 'H2C': [45.560, -73.665],
    'H2E': [45.550, -73.625], 'H2G': [45.535, -73.610], 'H2H': [45.525, -73.580],
    'H2J': [45.530, -73.580], 'H2K': [45.530, -73.555], 'H2L': [45.520, -73.560],
    'H2M': [45.555, -73.640], 'H2N': [45.555, -73.665], 'H2P': [45.540, -73.650],
    'H2R': [45.535, -73.625], 'H2S': [45.525, -73.610], 'H2T': [45.520, -73.590],
    'H2V': [45.520, -73.605], 'H2W': [45.515, -73.580], 'H2X': [45.510, -73.570],
    'H2Y': [45.505, -73.555], 'H2Z': [45.500, -73.560],
    'H3A': [45.500, -73.575], 'H3B': [45.500, -73.570], 'H3C': [45.495, -73.560],
    'H3E': [45.460, -73.555], 'H3G': [45.500, -73.580], 'H3H': [45.490, -73.585],
    'H3J': [45.490, -73.595], 'H3K': [45.480, -73.590], 'H3L': [45.555, -73.680],
    'H3M': [45.510, -73.715], 'H3N': [45.530, -73.620], 'H3P': [45.490, -73.635],
    'H3R': [45.495, -73.640], 'H3S': [45.485, -73.640], 'H3T': [45.490, -73.625],
    'H3V': [45.500, -73.620], 'H3W': [45.485, -73.625], 'H3X': [45.485, -73.610],
    'H3Y': [45.490, -73.605], 'H3Z': [45.475, -73.585],
    'H4A': [45.475, -73.620], 'H4B': [45.475, -73.605], 'H4C': [45.475, -73.595],
    'H4E': [45.460, -73.585], 'H4G': [45.460, -73.575], 'H4H': [45.450, -73.570],
    'H4J': [45.535, -73.700], 'H4K': [45.525, -73.700], 'H4L': [45.520, -73.685],
    'H4M': [45.515, -73.700], 'H4N': [45.520, -73.665], 'H4P': [45.500, -73.650],
    'H4R': [45.500, -73.685], 'H4S': [45.495, -73.700], 'H4T': [45.480, -73.660],
    'H4V': [45.475, -73.640], 'H4W': [45.465, -73.640], 'H4X': [45.465, -73.625],
    'H4Y': [45.470, -73.745], 'H4Z': [45.495, -73.560],
    'H8N': [45.435, -73.660], 'H8P': [45.430, -73.625], 'H8R': [45.450, -73.660],
    'H8S': [45.440, -73.665], 'H8T': [45.450, -73.715], 'H8Y': [45.445, -73.700],
    'H8Z': [45.430, -73.690],
    'H9A': [45.500, -73.770], 'H9B': [45.490, -73.760], 'H9C': [45.470, -73.870],
    'H9E': [45.450, -73.840], 'H9G': [45.500, -73.785], 'H9H': [45.490, -73.795],
    'H9J': [45.475, -73.815], 'H9K': [45.480, -73.870], 'H9P': [45.470, -73.770],
    'H9R': [45.460, -73.815], 'H9S': [45.450, -73.770], 'H9W': [45.455, -73.785],
    'H9X': [45.430, -73.940],
    // --- Laval ---
    'H7A': [45.575, -73.715], 'H7B': [45.620, -73.700], 'H7C': [45.640, -73.665],
    'H7E': [45.620, -73.665], 'H7G': [45.575, -73.745], 'H7H': [45.580, -73.770],
    'H7J': [45.605, -73.785], 'H7K': [45.595, -73.770], 'H7L': [45.595, -73.745],
    'H7M': [45.580, -73.700], 'H7N': [45.555, -73.715], 'H7P': [45.555, -73.770],
    'H7R': [45.530, -73.785], 'H7S': [45.555, -73.745], 'H7T': [45.530, -73.745],
    'H7V': [45.535, -73.720], 'H7W': [45.555, -73.735], 'H7X': [45.520, -73.815],
    'H7Y': [45.495, -73.835],
    // --- South Shore (Longueuil, Brossard, Saint-Lambert, Boucherville) ---
    'J3V': [45.533, -73.350], 'J3Y': [45.500, -73.420],
    'J4B': [45.605, -73.435], 'J4G': [45.535, -73.500], 'J4H': [45.530, -73.520],
    'J4J': [45.530, -73.510], 'J4K': [45.555, -73.495], 'J4L': [45.560, -73.475],
    'J4M': [45.580, -73.460], 'J4N': [45.620, -73.430], 'J4P': [45.500, -73.490],
    'J4R': [45.495, -73.510], 'J4S': [45.490, -73.500], 'J4T': [45.530, -73.450],
    'J4V': [45.475, -73.490], 'J4W': [45.460, -73.470], 'J4X': [45.450, -73.470],
    'J4Y': [45.470, -73.450], 'J4Z': [45.455, -73.470],
    // --- Châteauguay / Mercier / Beauharnois (south-west) ---
    'J5R': [45.405, -73.605], 'J5T': [45.430, -73.620],
    'J6J': [45.355, -73.745], 'J6K': [45.365, -73.755], 'J6N': [45.320, -73.870],
    'J6R': [45.310, -73.755],
    // --- North-of-Montreal (Repentigny, Mascouche, Terrebonne, Joliette) ---
    'J5Y': [45.745, -73.485], 'J5Z': [45.745, -73.465],
    'J6A': [45.745, -73.495], 'J6E': [46.022, -73.444],
    'J6V': [45.700, -73.620], 'J6W': [45.690, -73.640], 'J6X': [45.685, -73.660],
    'J6Y': [45.700, -73.665], 'J6Z': [45.715, -73.640],
    'J7A': [45.745, -73.620], 'J7B': [45.745, -73.560], 'J7C': [45.745, -73.580],
    'J7E': [45.700, -73.575], 'J7G': [45.715, -73.535], 'J7H': [45.745, -73.535],
    'J7J': [45.700, -73.535], 'J7K': [45.745, -73.600], 'J7L': [45.700, -73.700],
    'J7M': [45.700, -73.620],
    // --- Vaudreuil / West Island Off-island ---
    'J7P': [45.555, -73.940], 'J7R': [45.560, -73.910], 'J7T': [45.555, -73.965],
    'J7V': [45.400, -74.025], 'J7W': [45.400, -74.000], 'J7X': [45.395, -73.980],
    'J7Y': [45.780, -74.000], 'J7Z': [45.795, -74.000],
    // --- Saint-Jérôme / Mirabel (Laurentides edge) ---
    'J0R': [45.880, -74.180],   // Saint-Sauveur — borderline ~80 km
    'J8B': [46.015, -74.095],   // Sainte-Adèle area
    'J8E': [46.215, -74.595],   // Mont-Tremblant — clearly outside
    // --- Reference centroids well outside the zone ---
    'J2A': [45.900, -72.450],   // Drummondville (Saint-Joseph) — free-zone override
    'J2B': [45.880, -72.480],   // Drummondville (Saint-Charles) — free-zone override
    'J2C': [45.890, -72.480],   // Drummondville (centre-ville) — free-zone override
    'J2E': [45.860, -72.500],   // Drummondville (rural surrounds) — free-zone override
    'J1H': [45.400, -71.890],   // Sherbrooke
    'G8T': [46.345, -72.555],   // Trois-Rivières
    'G1A': [46.810, -71.210],   // Quebec City
    'J8L': [45.480, -75.710],   // Gatineau
    'G7H': [48.420, -71.060]    // Saguenay
  };

  function distanceKm(a, b) {
    var R = 6371;
    var toRad = function (d) { return d * Math.PI / 180; };
    var dLat = toRad(b[0] - a[0]);
    var dLon = toRad(b[1] - a[1]);
    var s1 = Math.sin(dLat / 2);
    var s2 = Math.sin(dLon / 2);
    var x = s1 * s1 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * s2 * s2;
    return 2 * R * Math.asin(Math.sqrt(x));
  }

  function normalize(pc) {
    return (pc || '').replace(/\s+/g, '').toUpperCase();
  }
  function isCanadian(pc) {
    return /^[A-CEGHJ-NPRSTVXY][0-9][A-CEGHJ-NPRSTV-Z][0-9][A-CEGHJ-NPRSTV-Z][0-9]$/.test(pc);
  }

  function t(key, fallback) {
    var src = (window.__pccI18n || {});
    return src[key] || fallback;
  }

  function bind(form) {
    var input  = form.querySelector('[data-pcc-input]');
    var result = form.querySelector('[data-pcc-result]');
    if (!input || !result) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      result.className = 'pcc__result';
      input.classList.remove('is-invalid');
      var pc = normalize(input.value);
      if (!isCanadian(pc)) {
        input.classList.add('is-invalid');
        result.classList.add('is-info');
        result.textContent = t('invalid', 'Code postal invalide. Format attendu : H2X 1Y4.');
        return;
      }
      var fsa = pc.slice(0, 3);
      var coord = QC_FSAS[fsa];
      if (!coord) {
        result.classList.add('is-info');
        result.textContent = t('unknown', 'Hors de notre base actuelle. Livraison payante disponible — contactez-nous pour un devis.');
        return;
      }
      var km = distanceKm(MONTREAL, coord);
      var rounded = km < 10 ? km.toFixed(1) : Math.round(km);
      var override = FREE_FSA_OVERRIDE.indexOf(fsa) !== -1;
      if (km <= FREE_KM || override) {
        result.classList.add('is-in-zone');
        result.textContent = (t('in_zone', '✅ {km} km — livraison gratuite') || '').replace('{km}', rounded);
      } else {
        result.classList.add('is-out-zone');
        result.textContent = (t('out_zone', '❌ {km} km — livraison payante disponible') || '').replace('{km}', rounded);
      }
    });
  }

  function bindCollapsible(root) {
    var trigger = root.querySelector('[data-pcc-trigger]');
    if (!trigger || trigger.__pccBound) return;
    trigger.__pccBound = true;
    trigger.addEventListener('click', function () {
      var expanded = !root.classList.contains('is-collapsed');
      if (expanded) {
        root.classList.add('is-collapsed');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        root.classList.remove('is-collapsed');
        trigger.setAttribute('aria-expanded', 'true');
        var input = root.querySelector('[data-pcc-input]');
        if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 50);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-pcc-form]').forEach(bind);
    document.querySelectorAll('.pcc--collapsible').forEach(bindCollapsible);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
